<div class='color-stripe'/>

<style>
  .color-stripe {
    height: 5px;

    background: var(--secondary);
  }

  :global(body.dark) .color-stripe {
    background: var(--secondary-dark);
  }
</style>
